<template>
  <div>
    <div v-html="$t('terms-of-service')" />
    <div class="clearfix" />
    <back-button />
  </div>
</template>

<script>
import BackButton from './BackButton'

export default {
  name: 'TermsOfService',
  components: { BackButton }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/variables';

div,
div {
  font-size: $font-size-md;
  color: $tangoTextPrimary;
}
</style>
